import {
    computed,
    EnvironmentProviders,
    inject,
    makeEnvironmentProviders,
} from '@angular/core';
import {
    provideCurrentLanguageCode,
    provideDefaultLanguageCode,
    provideLocaleDateFns,
} from '@interacta-shared/util-common';
import { ConfigurationService } from '../services/configuration.service';

// Bridges ConfigurationService into the generic shared util tokens, keeping shared libs free of app-specific dependencies.
export const provideLanguageConfig = (): EnvironmentProviders =>
    makeEnvironmentProviders([
        provideCurrentLanguageCode(() => {
            const svc = inject(ConfigurationService);
            return computed(() => svc.currentLanguage().code);
        }),
        provideDefaultLanguageCode(() => {
            const svc = inject(ConfigurationService);
            return computed(() => svc.defaultLanguage().code);
        }),
        provideLocaleDateFns(() =>
            inject(ConfigurationService).getLocaleDateFns(),
        ),
    ]);
